export function formatBadgeText (s) {
  if (s === undefined || s === 'N/A') {
    return '-'
  }
  const arr = s.replaceAll('/', ' ').split(' ')
  arr.map((d) => d[0].toUpperCase()).reduce((r, d) => r + d)
  return arr.map((d) => d[0]).reduce((r, d) => r + d)
}
